import { styled } from "@mui/material";
import { memo } from "react";
import Box from "../../../../node_modules/@mui/material/Box/Box.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Direction } from "../../../foundations/direction.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
const CustomBox = styled(Box)({
  display: Displaying.flex,
  flexDirection: Direction.column,
  gap: Spacing["1000"]
});
const DualGridCardLayoutColumn = memo(CustomBox);
export {
  DualGridCardLayoutColumn
};
//# sourceMappingURL=column-container.es.js.map
